module.exports = __webpack_public_path__ + "media/images/cortina-a8f79409.png";